import React, { useMemo } from 'react';
import styled from 'styled-components';

import { roundNumber } from 'src/common/helpers';
import { useAppSelector } from 'src/hooks';

const RatioWrapper = styled.div<{ askRatio: number }>`
    display: flex;
    width: 100%;
    height: 20px;
    overflow: hidden;
    border-radius: 5px;
    margin: 7px 0;
    padding: 0 5px;
    position: relative;

    .spacer {
        width: 15px;
    }

    .ask,
    .bid {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 35px !important;
        font-size: ${(props) => props.theme.typography.size.desktop.paragraph.p2};
        color: ${(props) => props.theme.colors.text.primary};
    }

    .bid {
        width: ${(props) => 100 - props.askRatio}%;
        background-color: ${(props) => props.theme.colors.exchange.buy};

        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: -5px;
            width: 10px;
            height: 100%;
            background-color: ${(props) => props.theme.colors.exchange.buy};
            transform: skewX(-25deg);
        }
    }

    .ask {
        width: ${(props) => props.askRatio}%;
        background-color: ${(props) => props.theme.colors.exchange.sell};

        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: -5px;
            width: 10px;
            height: 100%;
            background-color: ${(props) => props.theme.colors.exchange.sell};
            transform: skewX(-25deg);
        }
    }
`;

const OrderBookRatio = () => {
    const { sumMergedDepth } = useAppSelector((state) => state.socket);

    const askRatio = useMemo(() => {
        return sumMergedDepth.total
            ? roundNumber((sumMergedDepth.totalAsk / sumMergedDepth.total) * 100, 0)
            : 50;
    }, [sumMergedDepth]);

    return (
        <RatioWrapper askRatio={askRatio}>
            <div className="bid">{100 - askRatio}%</div>
            <div className="spacer" />
            <div className="ask">{askRatio}%</div>
        </RatioWrapper>
    );
};

export default OrderBookRatio;
